import { NgModule } from "@angular/core";
import { CoreModule } from "../../../core/core.module";
import { SharedModule } from "../../../shared/shared.module";
import { CreatePartnerComponent } from "./create-partner/create-partner.component";
import { ManagePartnerComponent } from "./manage-partner/manage-partner.component";
import { PartnerBulkUploadComponent } from "./partner-bulk-upload/partner-bulk-upload.component";
import { PartnersComponent } from "./partner.component";

@NgModule({
  declarations: [CreatePartnerComponent, ManagePartnerComponent, PartnerBulkUploadComponent, PartnersComponent],
  imports: [CoreModule, SharedModule],
  exports: [CreatePartnerComponent, ManagePartnerComponent, PartnerBulkUploadComponent, PartnersComponent],
})
export class PartnerModule {}
